import { useGetUserQuery } from 'feature/user/redux/user.api'
import { CompanyEditProfile } from 'feature/user/components/CompanyEditProfile/CompanyEditProfile'
import { UserEditProfile } from 'feature/user/components/UserEditProfile/UserEditProfile'
import { MainLayout } from 'layouts'
import { LoaderInCentalPosition } from 'widget'

export function UserSettingsProfilePage() {
  const { data, isLoading } = useGetUserQuery()

  if (isLoading) {
    return (
      <MainLayout>
        <LoaderInCentalPosition />
      </MainLayout>
    )
  }

  const isCompany = data?.clientType === 'company'

  return (
    <MainLayout>
      {isCompany ? <CompanyEditProfile /> : <UserEditProfile />}
    </MainLayout>
  )
}
